import { render, staticRenderFns } from "./VerificationPolicyButton.vue?vue&type=template&id=5781187a&scoped=true&"
import script from "./VerificationPolicyButton.vue?vue&type=script&lang=js&"
export * from "./VerificationPolicyButton.vue?vue&type=script&lang=js&"
import style0 from "./VerificationPolicyButton.vue?vue&type=style&index=0&id=5781187a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5781187a",
  null
  
)

export default component.exports